module.exports = __webpack_public_path__ + "img/assessment.7bb1b16b.svg";